import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";

export const CreateEventApi = createApi({
  reducerPath: "createEventApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    createEvent: builder.mutation({
      query: (data) => ({
        url: "/event",
        method: "POST",
        body: data
      })
    }),
    createEventV2: builder.mutation({
      query: (data) => ({
        url: "/event/sessionAgenda",
        method: "POST",
        body: data
      })
    }),
    createEventTemplate: builder.mutation({
      query: (data) => ({
        url: "/event/template",
        method: "POST",
        body: data
      })
    })
  })
});

export const {
  useCreateEventMutation,
  useCreateEventV2Mutation,
  useCreateEventTemplateMutation
} = CreateEventApi;
